import React from 'react';
import { useTranslation } from 'next-i18next';
import VcImage, { VCImageProps } from '@components/atoms/vc-images/vc-image';

interface ProfilePictureProps {
  picturePath: string | undefined;
  isUserProfile: boolean;
  userId?: string;
  ariaLabel?: string;
}

const ProfilePicture: React.FC<ProfilePictureProps & Partial<VCImageProps>> = (props) => {
  const { picturePath, isUserProfile, userId, ariaLabel, disableLazyLoad, alt, ...imageProps } = props;

  const { t: tA11y } = useTranslation('a11y');
  const isAvatarMissing = !picturePath || picturePath.includes('missing_avatar.gif');
  const defaultAlt = `${isUserProfile ? tA11y('A11Y.IMAGE.MY_AVATAR') : tA11y('A11Y.IMAGE.SELLER_AVATAR')} - ${userId}`;

  return (
    <VcImage
      {...imageProps}
      src={isAvatarMissing ? '/images/profile/missing_avatar.svg' : picturePath}
      disableLazyLoad={disableLazyLoad}
      alt={alt ?? defaultAlt}
      shouldUseAssetImage={isAvatarMissing}
      aria-label={ariaLabel}
    />
  );
};

export default ProfilePicture;
